// @ts-nocheck
import { useUiStore } from "src/components/main/uiStore";
// This can be save to sate store (the data is multiple weeks)
import { useState } from "react";
import exceljs from "exceljs";
import { saveAs } from "file-saver";
//---------------------------------------------------------------------
import Modal from "src/components/common/Modal";
import { useAuthStore } from "src/components/main/authStore";
import {
    onlyUnique, 
    mimeTypeMap, 
    myAxios, 
    exclusiveOutisdeKeys, 
    numberReducer, 
    getDateEndFromWeekNum, 
    calcLocate, 
    convertNumbersToLetters, 
    arrayReducer, 
    locatorWeeks as weeks} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function TicketNumbers(){
    const user = useAuthStore(state => state.user);
    const setShowLoader = useUiStore(state => state.setShowLoader);
    const [show, setShowForm] = useState(false);
    const [weekStart, setWeekStart] = useState("");
    const [weekEnd, setWeekEnd] = useState("");
    const handleTickesNumbers = (rawData) => {
        const forms = [];
        forms.push(...rawData.map(
            person => Object.fromEntries(Object.entries(person).map(
                entries => !exclusiveOutisdeKeys.includes(entries[0])?
                [entries[0], JSON.parse(entries[1] || 
                JSON.stringify({
                    "form":Array(7).fill({
                        "data": [], 
                        "status": "Created", 
                        "overnight": false
                    })}))]
                :
                entries
        ))));
        const totalData = [];
        const years = [];
        for(let f of forms){
            //const userName = f.userName;
            for(let key in f){
                if(!exclusiveOutisdeKeys.includes(key)){
                    years.push(key.slice(1, 5));
                    totalData.push(...f[key].form.filter(ff => ff.division).map(ff => (
                        {
                            year: key.slice(1, 5),
                            division: ff.division, 
                            numberTickets: ff.data
                            .filter(d => d.category === "job")
                            .map(j => j.ticketNumber),
                            pmNumbers: ff.data
                            .filter(d => d.category === "job")
                            .map(j => j.pmNumber)
                        }
                    )));
                }
            }
        }
        const uniqueYears = years.filter(onlyUnique);
        const ownYards = ["BTL Sacramento Yard", "BTL Hayward Yard", "BTL Fresno Yard", "In-House", "GPOM"];
        const divisions = totalData.map(t => t.division).filter(onlyUnique)
        .filter(t => !ownYards.includes(t));
        divisions.push(...ownYards);
        const workbook = new exceljs.Workbook();
        workbook.creator = user.userName.replace(/ {2}/g, " ");
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        for(let year of uniqueYears){
            const worksheet = workbook.addWorksheet(year, {
                views: [{ state: "frozen", ySplit: 1 }],
            });
            worksheet.state = "visible";
            const PMnumberByDivision = divisions
            .map(d => totalData
                .filter(t => t.division === d && t.year === year)
                .map(d => d.pmNumbers)
                .reduce((a, b) => ([...a, ...b]), []));

            const ticketsByDivision = divisions.map(d => totalData.filter(t => t.division === d && t.year === year).map(d => d.numberTickets).reduce((a, b) => ([...a, ...b]), []));
            const UniquePMnumbers = PMnumberByDivision.map(d => d.filter(onlyUnique)).reduce((a, b) => [...a, ...b], []).filter(onlyUnique);
            const UniqueTicketsByDivision = ticketsByDivision.map(d => d.filter(onlyUnique).length);
            //const ticketsByDivision = ticketsByDivision.map(d => d.length);
            worksheet.getRow(1).values = ["Division", ...divisions, "Total"];
            worksheet.getRow(2).values = ["Tickets", ...UniqueTicketsByDivision.map(d => d || ""), UniqueTicketsByDivision.reduce(numberReducer, 0) || ""];
            //worksheet.getRow(3).values = ["Tickets", ...ticketsByDivision.map(d => d || ""), UniqueTicketsByDivision.reduce(numberReducer, 0) || ""];
            const data = UniquePMnumbers.map(u => [u, ...PMnumberByDivision.map(p => p.filter(p => p === u).length)]);
            for(let i = 0; i < data.length; i++){
                worksheet.getRow(4 + i).values = data[i];
            }
        }
        //-------------------------------------------
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), 
            `Ticket Numbers from ${getDateEndFromWeekNum(weekStart)} to ${getDateEndFromWeekNum(weekEnd)}.xlsx`);
            setShowLoader(false);
        });
    }
    const handleTimeOffs = (rawData) => {
        const forms = [];
        forms.push(...rawData.map(
            person => Object.fromEntries(Object.entries(person).map(
                entries => !exclusiveOutisdeKeys.includes(entries[0])?
                [entries[0], JSON.parse(entries[1] || 
                JSON.stringify({
                    "form":Array(7).fill({
                        "status": "Created"
                    })}))]
                :
                entries
        ))));
        const totalData = [];
        const years = [];
        const weeks = [];
        const userNames = [];
        for(let f of forms){
            //const userName = f.userName;
            for(let key in f){
                if(!exclusiveOutisdeKeys.includes(key)){
                    years.push(key.slice(1, 5));
                    weeks.push(key);
                    userNames.push(f.userName);
                    totalData.push(...f[key].form.filter(ff => ff.status !== "Created" && ![
                        "Work", 
                        "Off Work"
                        // Sick, Vacation
                    ].includes(ff.workStatus)).map(ff => (
                        {
                            week: key,
                            userName: f.userName
                        }
                    )));
                }
            }
        }
        const uniqueYears = years.filter(onlyUnique).sort();
        const uniqueWeeks = weeks.filter(onlyUnique).sort();
        const uniqueUserNames = userNames.filter(onlyUnique).sort();

        const workbook = new exceljs.Workbook();
        workbook.creator = user.userName.replace(/ {2}/g, " ");
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        for(let year of uniqueYears){
            const worksheet = workbook.addWorksheet(year, {
                views: [{ state: "frozen", ySplit: 1 }],
            });
            worksheet.state = "visible";
            worksheet.getRow(1).values = ["Names", ...uniqueWeeks.filter(thisWeek => thisWeek.slice(1, 5) === year), "Total"];
            for(let i = 0; i < uniqueUserNames.length; i++){
                const userName = uniqueUserNames[i];
                const data = totalData.filter(d => d.week.slice(1, 5) === year && d.userName === userName);
                const rowData = uniqueWeeks.filter(thisWeek => thisWeek.slice(1, 5) === year).map(thisWeek => data.filter(d => d.week === thisWeek).length);
                worksheet.getRow(2 + i).values = [userName, ...rowData.map(d => d || ""), rowData.reduce(numberReducer, 0) || ""];
            }
            worksheet.columns.forEach(column => {
                const minLength = 18;
                let maxLength = 0;
                column["eachCell"]({ includeEmpty: true }, cell => {
                    const columnLength = cell.value?
                    cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1)
                    :minLength;
                    if(columnLength > maxLength){
                        maxLength = columnLength;
                    }
                });
                column.width = maxLength < minLength ? minLength : maxLength;
            });
        }
        //-------------------------------------------
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), 
            `Time Offs from ${getDateEndFromWeekNum(weekStart)} to ${getDateEndFromWeekNum(weekEnd)}.xlsx`);
            setShowLoader(false);
        });
    }
    const handleMobHours = (rawData) => {
        const forms = [];
        forms.push(...rawData.map(
            person => Object.fromEntries(Object.entries(person).map(
                entries => !exclusiveOutisdeKeys.includes(entries[0])?
                [entries[0], JSON.parse(entries[1] || 
                JSON.stringify({
                    "form":Array(7).fill({
                        "status": "Created"
                    })}))]
                :
                entries
        ))));
        const totalData = [];
        const years = [];
        const weeks = [];
        const userNames = [];
        for(let f of forms){
            //const userName = f.userName;
            for(let key in f){
                if(!exclusiveOutisdeKeys.includes(key)){
                    years.push(key.slice(1, 5));
                    weeks.push(key);
                    userNames.push(f.userName);
                    // console.log(f[key]);
                    totalData.push(...f[key].form.filter(ff => ff.status === "Submitted" && ff.workStatus === "Work")
                    .map(ff => (
                        {
                            ...calcLocate(ff),
                            week: key,
                            userName: f.userName
                        }
                    )));
                }
            }
        }
        const uniqueYears = years.filter(onlyUnique).sort();
        const uniqueWeeks = weeks.filter(onlyUnique).sort();
        const uniqueUserNames = userNames.filter(onlyUnique).sort();

        const workbook = new exceljs.Workbook();
        workbook.creator = user.userName.replace(/ {2}/g, " ");
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        for(let year of uniqueYears){
            const worksheet = workbook.addWorksheet(year, {
                views: [{ state: "frozen", ySplit: 1 }],
            });
            worksheet.state = "visible";
            const headers = ["Names"];
            for(const w of uniqueWeeks.filter(thisWeek => thisWeek.slice(1, 5) === year)){
                headers.push(w + " regular", w + " MOB regular", w + " ot", w + " MOB ot");
            }
            headers.push("Total regular", "Total Mob regular", "Total regular percentage", "Total ot", "Total Mob ot", "Total ot percentage");
            worksheet.getRow(1).values = headers;
            for(let i = 0; i < uniqueUserNames.length; i++){
                const userName = uniqueUserNames[i];
                const data = totalData.filter(d => d.week.slice(1, 5) === year && d.userName === userName);
                const rowData1 = uniqueWeeks.filter(thisWeek => thisWeek.slice(1, 5) === year).map(thisWeek => (data.filter(d => d.week === thisWeek).map(d => [
                    d.regular, d.mobReg, 
                    d.ot, d.mobOT, 
                ])).reduce((acc, cur) => [acc[0] + cur[0], acc[1] + cur[1], acc[2] + cur[2], acc[3] + cur[3]], [0, 0, 0, 0]));
                worksheet.getRow(2 + i).values = [userName, ...rowData1.reduce(arrayReducer, []).map(d => d || ""), 
                rowData1.map(d => d[0]).reduce(numberReducer, 0) || "",
                rowData1.map(d => d[1]).reduce(numberReducer, 0) || "",
                rowData1.map(d => d[0]).reduce(numberReducer, 0) !== 0 &&
                rowData1.map(d => d[1]).reduce(numberReducer, 0) !== 0?
                rowData1.map(d => d[1]).reduce(numberReducer, 0) / 
                rowData1.map(d => d[0]).reduce(numberReducer, 0) || "" : "",
                rowData1.map(d => d[2]).reduce(numberReducer, 0) || "",
                rowData1.map(d => d[3]).reduce(numberReducer, 0) || "",
                rowData1.map(d => d[2]).reduce(numberReducer, 0) !== 0 && 
                rowData1.map(d => d[3]).reduce(numberReducer, 0) !== 0?
                rowData1.map(d => d[3]).reduce(numberReducer, 0) / 
                rowData1.map(d => d[2]).reduce(numberReducer, 0) || "" : "",
            ];
            worksheet.getCell(2 + uniqueUserNames.length, 1).value = "Total";
            for(let i = 2; i < rowData1.length * 4 + 4; i++){
                const letter = convertNumbersToLetters(i);
                worksheet.getCell(2 + uniqueUserNames.length, i).value = {formula: `=SUM(${letter}2:${letter}${1 + uniqueUserNames.length})`};
            }

            worksheet.getCell(2 + uniqueUserNames.length, rowData1.length * 4 + 4).value = {formula: `=${convertNumbersToLetters(rowData1.length * 4 + 3)}${2 + uniqueUserNames.length}/${convertNumbersToLetters(rowData1.length * 4 + 2)}${2 + uniqueUserNames.length}`};

            worksheet.getCell(2 + uniqueUserNames.length, rowData1.length * 4 + 5).value = {formula: `=SUM(${convertNumbersToLetters(rowData1.length * 4 + 5)}2:${convertNumbersToLetters(rowData1.length * 4 + 5)}${1 + uniqueUserNames.length})`};
            worksheet.getCell(2 + uniqueUserNames.length, rowData1.length * 4 + 6).value = {formula: `=SUM(${convertNumbersToLetters(rowData1.length * 4 + 6)}2:${convertNumbersToLetters(rowData1.length * 4 + 6)}${1 + uniqueUserNames.length})`};

            worksheet.getCell(2 + uniqueUserNames.length, rowData1.length * 4 + 7).value = {formula: `=${convertNumbersToLetters(rowData1.length * 4 + 6)}${2 + uniqueUserNames.length}/${convertNumbersToLetters(rowData1.length * 4 + 5)}${2 + uniqueUserNames.length}`};

            worksheet.getColumn(rowData1.length * 4 + 4).numFmt = "0.00%";
            worksheet.getColumn(rowData1.length * 4 + 7).numFmt = "0.00%";

            worksheet.columns.forEach(column => {
                const minLength = 18;
                let maxLength = 0;
                column.numFmt = "0.00";
                column["eachCell"]({ includeEmpty: true }, cell => {
                    const columnLength = cell.value?
                    cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1)
                    :minLength;
                    if(columnLength > maxLength){
                        maxLength = columnLength;
                    }
                });
                column.width = maxLength < minLength ? minLength : maxLength;
            });
            worksheet.getColumn(rowData1.length * 4 + 4).numFmt = "0.00%";
            worksheet.getColumn(rowData1.length * 4 + 7).numFmt = "0.00%";
            }
        }
        //-------------------------------------------
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), 
            `Mob Hours from ${getDateEndFromWeekNum(weekStart)} to ${getDateEndFromWeekNum(weekEnd)}.xlsx`);
            setShowLoader(false);
        });
    }
    //--------------------------------------------------------------------------------------------
    return(
        <>
        <button type = "button" className = "btn btn-primary" onClick = {() => setShowForm(true)}>Export</button>
        {show?
        <Modal
            title = "Export"
            actionKey = "Export"
            width = "20rem"
            touchOutsideClose
            closeIt = {() => setShowForm(false)}
            handleFormSubmit = {async e => {
                const formData = new FormData(e.currentTarget);
                setShowLoader(true);
                const res = await myAxios({ fileName: "outside/locator/readTimeCards.php", formData: formData });
                setShowLoader(false);
                if(!res) return;
                if(!res.data.length){
                    window.alert("No data matched in current setting.");
                    return;
                }
                switch(formData.get("func")){
                    case "ticketNumbers":
                        handleTickesNumbers(res.data);
                        break;
                    case "timeOffs":
                        handleTimeOffs(res.data);
                        break;
                    case "mobHours":
                        handleMobHours(res.data);
                        break;
                    default:
                }

            }}
        >
            <div className = "d-flex align-items-center my-3">
                <label htmlFor = "weekStart">Week Start</label>
                <select
                    required
                    id = "weekStart"
                    name = "weekStart"
                    className = "form-control w-auto ms-2"
                    value = {weekStart}
                    onChange = {e => setWeekStart(e.currentTarget.value)}
                >
                    <option value = "">Select</option>
                    {weeks.map((thisWeek, weekIndex) => <option key = {weekIndex} value = {thisWeek}>{getDateEndFromWeekNum(thisWeek)}</option>)}
                </select>
            </div>
            <div className = "d-flex align-items-center my-3">
                <label htmlFor = "weekEnd">Week End</label>
                <select
                    required
                    id = "weekEnd"
                    name = "weekEnd"
                    className = "form-control w-auto ms-2"
                    value = {weekEnd}
                    onChange = {e => setWeekEnd(e.currentTarget.value)}
                >
                    <option value = "">Select</option>
                    {weeks.map((thisWeek, weekIndex) => <option key = {weekIndex} value = {thisWeek} disabled = {thisWeek < weekStart}>{getDateEndFromWeekNum(thisWeek)}</option>)}
                </select>
            </div>
            <div className = "d-flex align-items-center my-3">
                <label htmlFor = "ticketNumbers">Ticket Numbers</label>
                <input required name = "func" value = "ticketNumbers" id = "ticketNumbers" className = "cssCheckBox ms-2" type = "radio"/>
            </div>
            <div className = "d-flex align-items-center my-3">
                <label htmlFor = "timeOffs">Time Offs</label>
                <input required name = "func" value = "timeOffs" id = "timeOffs" className = "cssCheckBox ms-2" type = "radio"/>
            </div>
            <div className = "d-flex align-items-center my-3">
                <label htmlFor = "mobHours">Mob Hours</label>
                <input required name = "func" value = "mobHours" id = "mobHours" className = "cssCheckBox ms-2" type = "radio"/>
            </div>
        </Modal>
        :<></>}
        </>
    )
}